import { MenuItems } from './menu-items';

export const menu = [
  MenuItems.Bots,
  MenuItems.Connectors,
  MenuItems.Users,
  MenuItems.ChatQueue,
  MenuItems.Help,
  MenuItems.Pages
];
